import axios from '@/utils/axiosHelper';

// 初始化数据
export const onGetInitDataAPI = (params) => {
    return axios({ url: '/snail/fouth/index', method: 'GET', params }, { interceptResultCode: false });
};

// 领取奖励
export const getRewardApi = (params) => {
    return axios({ url: '/snail/fouth/reward', method: 'POST', params }, { interceptResultCode: false });
};

// 地址填写
export const modifyAddressApi = (params) => {
    return axios({ url: '/snail/fouth/address', method: 'POST', params }, { interceptResultCode: false });
};

// 创建订单
export const craeteOrderApi = (params) => {
    return axios({ url: '/snail/fouth/order', method: 'POST', params }, { interceptResultCode: false });
};

// 订单查询
export const checkOrderAPI = (params) => {
    return axios({ url: '/snail/fouth/order/show', method: 'GET', params }, { interceptResultCode: false });
};

// codeId查询api
export const wechatInfoAPI = (params) => {
    return axios({ url: '/wechat/info', method: 'GET', params }, { interceptResultCode: false });
};

// 订单超时
export const orderOff = (params) => {
    return axios({ url: '/snail/fouth/order/off', method: 'POST', params }, { interceptResultCode: false });
}

// 判断是否有库存
export const hasActualQuality = (params) => {
    return axios({ url: '/snail/fouth/info', method: 'GET', params }, { interceptResultCode: false });
}


// WEBPACK FOOTER //
// ./src/pages/snail/anniversary/api.js